module.exports = __webpack_public_path__ + "static/media/cc.2da4bb97.svg";